import { initPagingOptions } from '@/coreDomainsModule/paging';
import { orderTableContentHeader } from './tableContentProperties';
import { IUnorderedArrivalState } from '../pages/interfaces/unorderedArrival';
import { OrderGroupFactory } from '@/coreDomainsModule/factories/OrderGroupFactory';
import { simpleCopy } from '@/utils/deepCopy';
import { OrderGroupModalState } from '../constants';

/**
 * 発注一覧画面の初期状態を生成する関数
 * @returns 初期状態のIUnorderedArrivalStateオブジェクト
 */
export const orderTableStoreInitialValue = (): IUnorderedArrivalState => ({
  items: [],
  pagingOptions: initPagingOptions(30),
  sortKey: undefined,
  isAsc: true,
  loadingState: {
    status: {
      type: 'loading',
    },
  },
  registerOrderState: {
    status: {
      type: 'loading',
    },
  },
  tableContentItems: [],
  tableContentProperties: simpleCopy(orderTableContentHeader),
  checkedIds: [],
  orderReviseModalState: false,
  orderDeleteModalState: false,
  registerOrderModalState: false,
  changeConfirmModalState: false,
  exportOrderModalState: false,
  orderStatusFilterItem: {
    ApprovedAwaitingDeliveryDate: true,
    QuantityConfirmed: true,
    DeliveryDateConfirmed: true,
    PartialDelivery: true,
    Confirmed: true,
    Delivered: true,
    DeliveryDelayed: true,
    ApprovalRequested: false, // 「承認依頼」は発注一覧では表示しない
  },
  fileReadErrors: [], // エクセル読み取り時のエラーをまとめるためのオブジェクト
  outputErrorCsvData: [
    [
      '行番号',
      '置場名',
      '置場CD',
      '仕入先名',
      '仕入先CD',
      '商品名',
      '商品CD',
      '容量',
      '発注番号',
      '受注日',
      '納期/納入日',
      '発注番号',
      'エラー',
    ],
  ],
  editingOrderId: '',
  renderingKey: 0,
  updateMemoState: {
    loading: {
      status: {
        type: 'none',
      },
    },
    workType: 'update',
  },
  reminderData: [],
  orderGroupState: {
    openingModal: OrderGroupModalState.None,
    isOrderGroupEditMode: false,
    targetGroupName: '',
    editingGroup: OrderGroupFactory.create(),
    groupList: [],
    needChangeEstimatedTimeOfArrival: false,
    needCheckTotalAmount: false,
    originalOrderAmounts: {},
  },
  forcePagingNumber: undefined,
});
